import { FormlyFieldConfig } from '@ngx-formly/core';
import { AllegatiBolliAltroStep } from '../../shared/allegati-bolli-altro.step';

export const OccupazioneCommercioStep: FormlyFieldConfig[] = [
    {
        fieldGroup: [
            {
                wrappers: ['group-panel'],
                key: 'jd.elementi_occupazione',
                type: 'repeat',
                defaultValue: [],
                props: {
                    addText: '+ AGGIUNGI ELEMENTO',
                    label: 'ELEMENTI DI OCCUPAZIONE SUOLO (uno per riga)',
                },
                fieldArray: {
                    fieldGroup: [
                        {
                            fieldGroupClassName:
                                'border border-t-4 p-4 shadow-sm rounded-xl grid grid-flow-row-dense mb-2 sm:grid-cols-1 md:grid-cols-8 gap-4',
                            fieldGroup: [
                                {
                                    className: 'sm:col-span-1 md:col-span-1',
                                    key: 'lunghezza',
                                    type: 'mat-input',
                                    props: {
                                        label: 'LUNG. (m)',
                                        required: true,
                                        type: 'number',
                                    }
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-1',
                                    key: 'larghezza',
                                    type: 'mat-input',
                                    props: {
                                        label: 'LARG. (m)',
                                        required: true,
                                        type: 'number',
                                    }
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-6',
                                    key: 'descrizione',
                                    type: 'mat-input',
                                    props: {
                                        label: 'DESCRIZIONE/USO',
                                        required: true,
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        ],
    },

    {
        fieldGroup: [
            {
                wrappers: ['group-panel'],
                key: 'jd.elementi_tenda',
                defaultValue: [],
                type: 'repeat',
                fieldGroupClassName:
                    'flex flex-col border border-t-4 border-t-primary shadow-sm rounded-xl mb-6 mt-4 w-full',
                props: {
                    addText: '+ AGGIUNGI TENDA',
                    label: 'TENDE',
                },
                fieldArray: {
                    fieldGroupClassName:
                        ' border border-t-4 p-4 shadow-sm rounded-xl mb-2 grid md:grid-cols-6 mb-4 sm:grid-cols-1 gap-4 ',
                    fieldGroup: [
                        {
                            className: 'sm:col-span-1 md:col-span-3',
                            key: 'descrizione',
                            type: 'mat-input',
                            props: {
                                label: 'DESCRIZIONE',
                                required: true,
                            }
                        },
                        {
                            className: 'sm:col-span-1 md:col-span-3',
                            key: 'colore',
                            type: 'mat-input',
                            props: {
                                label: 'COLORE',
                                required: true,
                            },
                        },
                        {
                            className: 'sm:col-span-1 md:col-span-2',
                            key: 'lunghezza',
                            type: 'mat-input',
                            props: {
                                label: 'LUNGHEZZA (cm)',
                                required: true,
                                type: 'number',
                            },
                        },
                        {
                            className: 'sm:col-span-1 md:col-span-2',
                            key: 'altezzaterra',
                            type: 'mat-input',
                            props: {
                                label: 'ALTEZZA DA TERRA (cm)',
                                required: true,
                                type: 'number',
                                min: 250,
                            },
                        },
                        {
                            className: 'sm:col-span-1 md:col-span-2',
                            key: 'sporgenza',
                            type: 'mat-input',
                            props: {
                                label: 'SPORGENZA FILO MURO',
                                required: true,
                                type: 'number',
                                max: 150,
                            },
                        },
                        {
                            className: 'sm:col-span-1 md:col-span-2',
                            key: 'bucatura_sx',
                            type: 'mat-input',
                            props: {
                                label: 'SPORGENZA BUCATURA SX',
                                required: true,
                                type: 'number',
                                max: 30,
                            },
                        },
                        {
                            className: 'sm:col-span-1 md:col-span-2',
                            key: 'bucatura_dx',
                            type: 'mat-input',
                            props: {
                                label: 'SPORGENZA BUCATURA DX',
                                required: true,
                                type: 'number',
                                max: 30,
                            },
                        },
                        {
                            className:
                                'sm:col-span-1 md:col-span-2 radio-inline',
                            key: 'messaggio',
                            type: 'mat-radio',
                            props: {
                                label: 'MESSAGGIO PUBBLICITARIO',
                                required: true,
                                type: 'number',
                                color: 'primary',
                                description: 'SOLO SU MANTOVANA',
                                options: [
                                    { value: 'si', label: 'SI' },
                                    { value: 'no', label: 'NO' },
                                ],
                            },
                        },
                    ],
                },
            },
        ],
    },

    {
        fieldGroup: [
            {
                wrappers: ['group-panel'],
                key: 'jd.elementi_lampada',
                type: 'repeat',
                defaultValue: [],
                fieldGroupClassName:
                    'flex flex-col border border-t-4 border-t-primary shadow-sm rounded-xl mb-6 mt-4 w-full',
                props: {
                    addText: '+ AGGIUNGI LAMPADA',
                    label: 'LAMPADE',
                },
                fieldArray: {
                    fieldGroup: [
                        {
                            fieldGroupClassName:
                                'border border-t-4 p-4 shadow-sm rounded-xl mb-2 grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-6 gap-4',
                            fieldGroup: [
                                {
                                    className: 'sm:col-span-1 md:col-span-6',
                                    key: 'descrizione',
                                    type: 'mat-input',
                                    props: {
                                        label: 'DESCRIZIONE',
                                        required: true,
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-2',
                                    key: 'altezzaterra',
                                    type: 'mat-input',
                                    props: {
                                        label: 'ALTEZZA DA TERRA (cm)',
                                        required: true,
                                        type: 'number',
                                        min: 350,
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-2',
                                    key: 'sporgenza',
                                    type: 'mat-input',
                                    props: {
                                        label: 'SPORGENZA FILO MURO (cm)',
                                        required: true,
                                        type: 'number',
                                        max: 15,
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-2',
                                    key: 'potenza',
                                    type: 'mat-input',
                                    props: {
                                        label: 'POTENZA [watt]',
                                        required: true,
                                        type: 'number',
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        ],
    },

    {
        fieldGroup: [
            {
                wrappers: ['group-panel'],
                key: 'jd.elementi_insegna',
                type: 'repeat',
                defaultValue: [],
                fieldGroupClassName:
                    'flex flex-col border border-t-4 border-t-primary shadow-sm rounded-xl mb-6 mt-4 w-full',
                props: {
                    addText: '+ AGGIUNGI INSEGNA',
                    label: 'INSEGNE E/O VETROFANIE (intesa come insegna del negozio)',
                },
                fieldArray: {
                    fieldGroupClassName:
                        'border border-t-4 p-4 shadow-sm rounded-xl mb-2 grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-6 gap-4',
                    fieldGroup: [
                        {
                            className: 'sm:col-span-1 md:col-span-6',
                            key: 'descrizione',
                            type: 'mat-input',
                            props: {
                                label: 'DESCRIZIONE',
                                required: true,
                                autosize: true,
                                autosizeMaxRows: 8,
                                autosizeMinRows: 2,
                            },
                        },
                        {
                            className: 'sm:col-span-1 md:col-span-2',
                            key: 'lunghezza',
                            type: 'mat-input',
                            props: {
                                label: 'LUNGHEZZA (cm)',
                                required: true,
                                type: 'number',
                            },
                        },
                        {
                            className: 'sm:col-span-1 md:col-span-2',
                            key: 'altezza',
                            type: 'mat-input',
                            props: {
                                label: 'ALTEZZA (cm)',
                                required: true,
                                type: 'number',
                            },
                        },
                        {
                            className: 'sm:col-span-1 md:col-span-2',
                            key: 'spessore',
                            type: 'mat-input',
                            props: {
                                label: 'SPESSORE (cm)',
                                required: true,
                                type: 'number',
                            },
                        },

                        {
                            className: 'sm:col-span-1 md:col-span-2',
                            key: 'altezzaterra',
                            type: 'mat-input',
                            props: {
                                label: 'ALTEZZA DA TERRA (cm)',
                                required: true,
                                type: 'number',
                            },
                        },
                        {
                            className: 'sm:col-span-1 md:col-span-2',
                            key: 'sporgenza',
                            type: 'mat-input',
                            props: {
                                label: 'SPORGENZA FILO MURO (cm)',
                                required: true,
                                type: 'number',
                            }
                        },
                        {
                            className:
                                'sm:col-span-1 md:col-span-2 radio-inline',
                            key: 'messaggio',
                            type: 'mat-radio',
                            props: {
                                label: 'MESSAGGIO PUBBLICITARIO',
                                color: 'primary',
                                required: true,
                                options: [
                                    { value: 'si', label: 'SI' },
                                    { value: 'no', label: 'NO' },
                                ],
                            },
                        },
                    ],
                },
            },
        ],
    },

    {
        fieldGroup: [
            {
                wrappers: ['group-panel'],
                key: 'jd.elementi_fioriera',
                type: 'repeat',
                defaultValue: [],
                fieldGroupClassName:
                    'flex flex-col border border-t-4 border-t-primary shadow-sm rounded-xl mb-6 mt-4 w-full',
                props: {
                    addText: '+ AGGIUNGI UNA FIORIERA',
                    label: 'FIORIERE O ALTRI ELEMENTI ORNAMENTALI',
                },
                fieldArray: {
                    fieldGroup: [
                        {
                            fieldGroupClassName:
                                'border border-t-4 p-4 shadow-sm rounded-xl mb-2 grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-6 gap-4',
                            fieldGroup: [
                                {
                                    className: 'sm:col-span-1 md:col-span-6',
                                    key: 'descrizione',
                                    type: 'mat-textarea',
                                    props: {
                                        label: 'DESCRIZIONE',
                                        required: true,
                                        autosize: true,
                                        autosizeMaxRows: 8,
                                        autosizeMinRows: 2,
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-2',
                                    key: 'lunghezza',
                                    type: 'mat-input',
                                    props: {
                                        label: 'LUNGHEZZA (cm)',
                                        required: true,
                                        type: 'number',
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-2',
                                    key: 'larghezza',
                                    type: 'mat-input',
                                    props: {
                                        label: 'LARGHEZZA (cm)',
                                        required: true,
                                        type: 'number',
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-2',
                                    key: 'altezza',
                                    type: 'mat-input',
                                    props: {
                                        label: 'ALTEZZA (cm)',
                                        required: true,
                                        type: 'number',
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        ],
    },

    {
        fieldGroup: [
            {
                wrappers: ['group-panel'],
                key: 'jd.elementi_cavalletto',
                type: 'repeat',
                defaultValue: [],
                fieldGroupClassName:
                    'flex flex-col border border-t-4 border-t-primary shadow-sm rounded-xl mb-6 mt-4 w-full',
                props: {
                    addText: '+ AGGIUNGI CAVALLETTO',
                    label: 'CAVALLETTI PUBBLICITARI E BANNER CON CONTENUTI PUBBLICITARI',
                },
                fieldArray: {
                    fieldGroup: [
                        {
                            fieldGroupClassName:
                                'border border-t-4 p-4 shadow-sm rounded-xl mb-2 grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-4 gap-4 md:w-280 sm:w-full',
                            fieldGroup: [
                                {
                                    className: 'sm:col-span-1 md:col-span-4',
                                    template: `SUPERFICI IN METRI QUADRATI DELLE FACCE DEL CAVALLETTO O BANNER CON CONTENUTI PUBBLICITARI:`,
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-1',
                                    key: 'sup_1',
                                    type: 'mat-input',
                                    props: {
                                        label: 'FACCIA 1 (mq)',
                                        required: true,
                                        type: 'number',
                                    },

                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-1',
                                    key: 'sup_2',
                                    type: 'mat-input',
                                    props: {
                                        label: 'FACCIA 2 (mq)',
                                        type: 'number',
                                    },

                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-1',
                                    key: 'sup_3',
                                    type: 'mat-input',
                                    props: {
                                        label: 'FACCIA 3 (mq)',
                                        type: 'number',
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-1',
                                    key: 'sup_4',
                                    type: 'mat-input',
                                    props: {
                                        label: 'FACCIA 4 (mq)',
                                        type: 'number',
                                    },
                                },
                                {
                                    className:
                                        'sm:col-span-1 md:col-span-4 mt-4',
                                    template: `DIMENSIONI OCCUPAZIONE SUOLO (impronta a terra):`,
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-1',
                                    key: 'lunghezza',
                                    type: 'mat-input',
                                    props: {
                                        label: 'LUNGHEZZA a terra (m)',
                                        required: true,
                                        type: 'number',
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-1',
                                    key: 'larghezza',
                                    type: 'mat-input',
                                    props: {
                                        label: 'LARGHEZZA a terra (m)',
                                        type: 'number',
                                        required: true,
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-1',
                                    key: 'altezzaterra',
                                    type: 'mat-input',
                                    props: {
                                        label: 'ALTEZZA da terra (m)',
                                        type: 'number',
                                        description:
                                            'Inserire un valore inferiore a 1 metro',
                                        required: true,
                                        max: 1,
                                    },
                                },
                                {
                                    className:
                                        'sm:col-span-1 md:col-span-1 radio-inline',
                                    key: 'illuminato',
                                    type: 'mat-radio',
                                    props: {
                                        label: 'CAVALLETTO ILLUMINATO',
                                        required: true,
                                        color: 'primary',
                                        options: [
                                            { value: 'si', label: 'SI' },
                                            { value: 'no', label: 'NO' },
                                        ],
                                        description: 'SI maggiorazione CIMP',
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-4',
                                    key: 'posizione',
                                    type: 'mat-select',
                                    props: {
                                        label: 'POSIZIONE',
                                        required: true,
                                        color: 'primary',
                                        options: [
                                            { value: null, label: '' },
                                            {
                                                value: 1,
                                                label: "Cavalletto nelle vetrine, nelle porte d'ingresso dell'esercizio e comunque all'interno del locale (esente COSAP e CIMP)",
                                            },
                                            {
                                                value: 2,
                                                label: "Cavalletto nelle immediate adiacenze dell'esercizio (esente CIMP)",
                                            },
                                            {
                                                value: 3,
                                                label: "Cavalletto non adiacente ma comunque all'interno dell'area di pertinenza dell'attività",
                                            },
                                            {
                                                value: 4,
                                                label: "Cavalletto fuori dell'area di pertinenza dell'attività",
                                            },
                                            {
                                                value: 5,
                                                label: "Banner all'interno dell'area di pertinenza dell'attività",
                                            },
                                        ],
                                        change: (field) =>
                                            field.parent
                                                .get(`${field.key}_value`)
                                                .formControl.setValue(
                                                    (
                                                        field.props
                                                            .options as Array<{
                                                            value: any;
                                                            label: string;
                                                        }>
                                                    ).filter(
                                                        (x) =>
                                                            x.value ==
                                                            field.formControl
                                                                .value,
                                                    )[0].label,
                                                ),
                                    },
                                },
                                {
                                    key: 'posizione_value',
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-4',
                                    key: 'via',
                                    type: 'mat-autocomplete',
                                    props: {
                                        label: 'VIA',
                                        required: true,
                                    },
                                    validation: {
                                        show: true,
                                    },
                                    validators:{
                                        validation:['AutocompleteMatch'],
                                    },
                                    expressions: {
                                        hide: 'model?.posizione != 4',
                                    },
                                    hooks: {
                                        onInit: (field) =>
                                            (field.props.filter = (
                                                term: string,
                                            ) =>
                                                field.options.formState.cmp._ubicazioneService.getViaByTerm(
                                                    term,
                                                )),
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-4',
                                    key: 'descrizione',
                                    type: 'mat-textarea',
                                    props: {
                                        label: 'Descrizione della posizione del cavalletto',
                                        required: true,
                                        autosize: true,
                                        autosizeMaxRows: 8,
                                        autosizeMinRows: 2,
                                    },

                                    expressions: {
                                        hide: '!model?.via',
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        ],
    },

    {
        fieldGroup: [
            {
                wrappers: ['group-panel'],
                key: 'jd.messaggi_pubblicitari',
                type: 'repeat',
                defaultValue: [],
                fieldGroupClassName:
                    'flex flex-col border border-t-4 border-t-primary shadow-sm rounded-xl mb-6 mt-4 w-full',
                props: {
                    addText: '+ AGGIUNGI MESSAGGIO PUBBLICITARIO',
                    label: 'MESSAGGIO PUBBLICITARIO TRAMITE SCHERMO/TELEVISORE',
                },
                fieldArray: {
                    fieldGroup: [
                        {
                            fieldGroupClassName:
                                'border border-t-4 p-4 shadow-sm rounded-xl mb-2 grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-3 gap-4 md:w-280 sm:w-full',
                            fieldGroup: [
                                // {
                                //     "className": 'sm:col-span-1 md:col-span-4',
                                //     "template": `SUPERFICI IN METRI QUADRATI DELLE FACCE DEL CAVALLETTO O BANNER CON CONTENUTI PUBBLICITARI:`
                                //   },
                                {
                                    className: 'sm:col-span-1 md:col-span-1',
                                    key: 'lunghezza',
                                    type:'mat-input',
                                    props: {
                                        label: 'LUNGHEZZA',
                                        required: true,
                                        type: 'number',
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-1',
                                    key: 'larghezza',
                                    type:'mat-input',
                                    props: {
                                        label: 'LARGHEZZA',
                                        required: true,
                                        type: 'number',
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-1',
                                    key: 'profondita',
                                    type: 'mat-input',
                                    props: {
                                        label: 'PROFONDITÀ',
                                        required: true,
                                        type: 'number',
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-1',
                                    key: 'tipologia_mezzo',
                                    type: 'mat-input',
                                    props: {
                                        label: 'TIPOLOGIA DEL MEZZO DI DIFFUSIONE PUBBLICITARIA',
                                        required: true,
                                    },
                                },
                                {
                                    className: 'sm:col-span-1 md:col-span-2',
                                    key: 'tipo_gestione',
                                    type: 'mat-input',
                                    props: {
                                        label: 'SPECIFICARE SE È PER CONTO PROPRIO O PER CONTO ALTRUI',
                                        required: true,
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        ],
    },
    {
        className: 'sm:col-span-1 md:col-span-6',
        key: 'jd.descrizione_occupazione',
        type: 'mat-textarea',
        defaultValue: '',
        props: {
            label: "DESCRIZIONE GENERICA DEGLI ELEMENTI PRESENTI ALL'INTERNO DELL'AREA DI OCCUPAZIONE",
            required: true,
            autosize: true,
            autosizeMaxRows: 8,
            autosizeMinRows: 4,
        },
    },
    {
        className: 'sm:col-span-1 md:col-span-6',
        key: 'jd.note_occupazione',
        type: 'mat-textarea',
        defaultValue: '',
        props: {
            label: 'NOTE',
            autosize: true,
            autosizeMaxRows: 8,
            autosizeMinRows: 2,
        },
    },
            ...AllegatiBolliAltroStep
];
